// extracted by mini-css-extract-plugin
export default {"cls1":"PayoutDetailsFields-Error_cls1__osVFv","cls2":"PayoutDetailsFields-Error_cls2__KNg3V PayoutDetailsFields-Error_cls1__osVFv"};